import axios from 'axios';
import { getHeaders } from '../../../../builder/utils/getToken';

import { API_BASE_URL } from '../../../../builder/services/api/configuration/config';
import { USERMANAGEMENT_API_BASE_URL } from '../../../../builder/services/api/configuration/config';
import { DOCGENERATION_API_BASE_URL } from '../../../../builder/services/api/configuration/config';
import { APPLICATION_API_BASE_URL } from '../../../../builder/services/api/configuration/config';

export async function registerUser(payload) {
  try {
    const data = await axios.post(`${USERMANAGEMENT_API_BASE_URL}/auth/register`, payload);
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error registering user: ${err}`);
    throw new Error('New user not registered');
  }
}

export async function verifyEmail(payload) {
  try {
    const data = await axios.post(`${USERMANAGEMENT_API_BASE_URL}/auth/verify-register`, payload);
    const res = data.data.data;
    return res;
  } catch (err) {
    console.error(`Error verifing email: ${err}`);
    throw new Error('Incorrect code entered');
  }
}
//write api for forget password
export async function forgetPassword(payload) {
  try {
    const data = await axios.post(`${USERMANAGEMENT_API_BASE_URL}/auth/forgot-password`, payload);
    return data;
  } catch (err) {
    console.error(`Error forget password: ${err}`);
    throw new Error('Incorrect email entered');
  }
}

export async function confirmForgotPassword(payload) {
  try {
    const data = await axios.post(
      `${USERMANAGEMENT_API_BASE_URL}/auth/forgot-password/confirm`,
      payload
    );
    return data;
  } catch (err) {
    console.error(`Error confirming forgot password: ${err}`);
    throw new Error('Unable to confirm forgot password');
  }
}

export async function loginUser(payload) {
  try {
    const data = await axios.post(`${USERMANAGEMENT_API_BASE_URL}/auth/login`, payload);
    const token = data?.data?.data?.token || data?.data?.accessToken;
    if (token) {
      localStorage.setItem('accessToken', token);
    }
    return data;
  } catch (err) {
    console.error(`Error login user: ${err}`);
    throw new Error('Incorrect email or password');
  }
}

export async function completeNewPassword(payload) {
  try {
    const data = await axios.post(
      `${USERMANAGEMENT_API_BASE_URL}/auth/complete-new-password`,
      payload
    );
    return data;
  } catch (err) {
    console.error(`Error completing new password challenge: ${err}`);
    throw new Error('Unable to complete new password challenge');
  }
}

export async function uploadImage(payload) {
  console.log('Comiung to upload image function');

  try {
    const data = await axios.post(`${APPLICATION_API_BASE_URL}/s3/upload`, payload);
    return data.data;
  } catch (err) {
    console.error(`Error uploading file: ${err}`);
    throw new Error('Error uploading file');
  }
}

export async function uploadMultiple(payload) {
  console.log('Comiung to upload image function');

  try {
    const data = await axios.post(`${APPLICATION_API_BASE_URL}/s3/uploads`, payload);
    return data.data;
  } catch (err) {
    console.error(`Error uploading file: ${err}`);
    throw new Error('Error uploading file');
  }
}

export async function sendOtp(payload) {
  try {
    const data = await axios.post(`${USERMANAGEMENT_API_BASE_URL}/auth/login-phone`, payload);
    return data;
  } catch (err) {
    console.error(`Error sending OTP: ${err}`);
    throw new Error('Error sending OTP');
  }
}

export async function verifyOtp(payload) {
  try {
    const data = await axios.post(`${USERMANAGEMENT_API_BASE_URL}/auth/login-phone`, payload);
    localStorage.setItem('accessToken', data.data.accessToken);
    return data;
  } catch (err) {
    console.error(`Error verifying OTP: ${err}`);
    throw new Error('Incorrect OTP');
  }
}

// Reset Password

export async function createPassword(payload) {
  try {
    const data = await axios.post(`${USERMANAGEMENT_API_BASE_URL}/auth/reset`, payload);
    return data;
  } catch (err) {
    console.error(`Error create Password: ${err}`);
    throw new Error('Incorrect create Password');
  }
}

export async function sendResetPasswordCode(payload) {
  try {
    const data = await axios.post(`${USERMANAGEMENT_API_BASE_URL}/auth/verify-register`, payload);
    return data;
  } catch (err) {
    console.error(`Error sending reset password code: ${err}`);
    throw new Error('Unable to send reset code');
  }
}

export async function resetPasswordWithCode(payload) {
  try {
    const data = await axios.post(`${USERMANAGEMENT_API_BASE_URL}/auth/reset`, payload);
    return data;
  } catch (err) {
    console.error(`Error resetting password: ${err}`);
    throw new Error('Unable to reset password');
  }
}

export async function getCognitoStatus(payload) {
  try {
    const headers = await getHeaders();
    const data = await axios.post(
      `${USERMANAGEMENT_API_BASE_URL}/auth/cognito-status`,
      payload,
      headers
    );
    return data.data?.data;
  } catch (err) {
    console.error(`Error getting cognito status: ${err}`);
    throw new Error('Unable to fetch Cognito status');
  }
}

export async function resendInvitation(payload) {
  try {
    const headers = await getHeaders();
    const data = await axios.post(
      `${USERMANAGEMENT_API_BASE_URL}/auth/resend-invitation`,
      payload,
      headers
    );
    return data.data;
  } catch (err) {
    console.error(`Error resending invitation: ${err}`);
    throw new Error('Unable to resend invitation');
  }
}
